module.exports = __webpack_public_path__ + "img/dyzg.679017dc.jpg";